import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { Link } from "react-router-dom";

const COLS = ["Under Review", "Sourcing", "Quoting", "Comparison", "Awarded", "Delivered"];

export default function Kanban() {
  const [rfqs, setRfqs] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/rfqs"); setRfqs(data); })(); }, []);

  const byCol = (c) => rfqs.filter((r) => r.status === c);

  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow">Pipeline</div>
        <h1 className="font-display text-3xl font-extrabold text-[#0A2540] tracking-tight mt-1">RFQ Kanban</h1>
      </div>
      <div className="kanban flex gap-4 pb-4">
        {COLS.map((col) => (
          <div key={col} className="min-w-[280px] w-[280px] flex-shrink-0" data-testid={`kanban-col-${col}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="text-xs font-bold uppercase tracking-wider text-slate-700">{col}</div>
              <span className="text-xs font-mono-num text-slate-500 bg-slate-100 px-2 py-0.5 rounded">{byCol(col).length}</span>
            </div>
            <div className="space-y-2">
              {byCol(col).map((r) => (
                <Link key={r.id} to={`/app/rfqs/${r.id}`} className="block bg-white border border-slate-200 rounded-lg p-3 hover:shadow-sm transition-shadow relative overflow-hidden" data-testid={`kanban-card-${r.id}`}>
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#0A2540]" />
                  <div className="font-mono-num text-[10px] text-slate-400">{r.reference}</div>
                  <div className="text-sm font-medium text-[#0A2540] mt-0.5 leading-snug">{r.title}</div>
                  <div className="text-xs text-slate-500 mt-2">{r.buyer?.company_name}</div>
                  <div className="mt-2 flex items-center justify-between text-xs">
                    <span className="text-slate-400">{r.category}</span>
                    {r.target_budget && <span className="font-mono-num font-semibold text-[#0A2540]">{money(r.target_budget)}</span>}
                  </div>
                </Link>
              ))}
              {byCol(col).length === 0 && <div className="text-xs text-slate-400 text-center py-6 border border-dashed border-slate-200 rounded-lg">Empty</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
